document.addEventListener("DOMContentLoaded", () => {
  const productItems = document.querySelectorAll('.product-item');

  productItems.forEach((item) => {
    const productMeta = item.querySelector('.product-item__meta');
    const overlay = item.querySelector('.product-meta-overlay');

    if (productMeta && overlay) {
      productMeta.addEventListener('mouseenter', () => {
        overlay.classList.add('meta-overlay-active');
      });

      productMeta.addEventListener('mouseleave', () => {
        overlay.classList.remove('meta-overlay-active');
      });
    }
  });

  
});
